// ============================================
// Creator Events - Autofill (ES6)
// 자동채우기 모달 이벤트
// ============================================

import {
  closeAutofillModal, switchAutofillTab,
  toggleAutofillImageOption,
  confirmAutofill, confirmFullGenerate,
  handleFullGenModeChange, toggleFullGenImageOption
} from '../index.js';

// ============================================
// 자동채우기 모달 이벤트
// ============================================

export function initAutofillModalEvents() {
  const modal = document.getElementById('autofillConfirmModal');
  if (!modal) return;

  // 뒤로가기 버튼
  modal.querySelector('.detail-back-btn')?.addEventListener('click', closeAutofillModal);

  // 탭 버튼 (이벤트 위임)
  modal.querySelector('.story-autofill-tabs')?.addEventListener('click', (e) => {
    const tab = e.target.closest('.story-autofill-tab');
    if (tab) {
      const tabName = tab.dataset.tab;
      if (tabName) switchAutofillTab(tabName);
    }
  });

  // 이미지 자동 생성 토글
  document.getElementById('autofillAutoImage')?.addEventListener('change', toggleAutofillImageOption);

  // 채우기 버튼 (자동 채우기 탭)
  document.querySelector('#charAutofillTabFill .autofill-submit-btn')?.addEventListener('click', confirmAutofill);

  // 생성 모드 라디오 버튼 (전체 자동 생성 탭)
  document.querySelectorAll('input[name="charFullGenMode"]').forEach(radio => {
    radio.addEventListener('change', handleFullGenModeChange);
  });

  // 이미지 자동 생성 토글 (전체 자동 생성 탭)
  document.getElementById('charFullGenAutoImage')?.addEventListener('change', toggleFullGenImageOption);

  // 생성 버튼 (전체 자동 생성 탭)
  document.querySelector('#charAutofillTabGenerate .autofill-submit-btn')?.addEventListener('click', confirmFullGenerate);
}
